<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref, onMounted, onBeforeUnmount, computed, defineProps } from "vue";
import firstSlide from "../assets/images/hero-slide-1.gif";
import secondSlide from "../assets/images/hero-slide-3.jpeg";
import fourthSlide from "../assets/images/hero-slide-5.png";
import Button from "./Button.vue";

// menu scroll func
const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);
  section.scrollIntoView({ behavior: "smooth" });
};

// typewritter effect
const typeValue = ref("");
const typeStatus = ref(false);
const displayTextArray = [
  "I am a Graphics Designer...",
  "I am a Photographer...",
  "I am a Videographer",
  "I am a Freelancer...",
];
const typingSpeed = 100;
const erasingSpeed = 100;
const newTextDelay = 1000;
let displayTextArrayIndex = 0;
let charIndex = 0;

const typeText = () => {
  if (charIndex < displayTextArray[displayTextArrayIndex].length) {
    if (!typeStatus.value) typeStatus.value = true;
    typeValue.value +=
      displayTextArray[displayTextArrayIndex].charAt(charIndex);
    charIndex += 1;
    setTimeout(typeText, typingSpeed);
  } else {
    typeStatus.value = false;
    setTimeout(eraseText, newTextDelay);
  }
};

const eraseText = () => {
  if (charIndex > 0) {
    if (!typeStatus.value) typeStatus.value = true;
    typeValue.value = displayTextArray[displayTextArrayIndex].substring(
      0,
      charIndex - 1
    );
    charIndex -= 1;
    setTimeout(eraseText, erasingSpeed);
  } else {
    typeStatus.value = false;
    displayTextArrayIndex += 1;
    if (displayTextArrayIndex >= displayTextArray.length)
      displayTextArrayIndex = 0;
    setTimeout(typeText, typingSpeed + 1000);
  }
};

onMounted(() => {
  setTimeout(typeText, newTextDelay + 200);
});

// image slideshow

const images = [firstSlide, secondSlide, fourthSlide];
const currentIndex = ref(0);
const currentImage = computed(() => images[currentIndex.value]);

let slideshowInterval;
const startSlideshow = () => {
  // Use setInterval to change the current index every 4.5 seconds
  slideshowInterval = setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % images.length;
  }, 4500);
};
const stopSlideshow = () => {
  // Use clearInterval to stop the slideshow interval
  clearInterval(slideshowInterval);
};

onMounted(startSlideshow);
onBeforeUnmount(stopSlideshow);

// mobile menu func
let open = ref(false);
const menuOpen = () => {
  open.value = !open.value;
};

setInterval(() => {
  open.value === true ? (open.value = false) : open.value;
}, 10000);

// props
const text = "Hire me";
defineProps({
  navItems: {
    type: Array,
  },
  text: {
    type: String,
  },
  link: {
    type: String,
  },
});
</script>

<template>
  <section class="header-ctn ">
    <!-- nav bar -->
    <nav class="w-full flex justify-end items-center">
      <!-- logo -->
      <div
        class="w-[185px] md:w-[250px] absolute -left-8 md:left-0 -top-5 md:-top-10"
      >
        <img src="../assets/images/emix-logo2-unscreen.gif" alt="emix-logo" />
      </div>
      <!-- mobile-nav-buttons -->
      <div
        class="absolute right-5 top-10 cursor-pointer md:hidden"
        @click="menuOpen"
      >
        <i
          class="text-white text-4xl"
          :class="[open ? 'bi bi-x' : 'bi bi-filter-left']"
        >
        </i>
      </div>
      <!-- nav-items -->
      <div
        class="flex flex-col md:flex-row justify-center md:justify-between items-center w-[100%] h-[75vh] md:h-auto md:w-[35%] my-0 md:my-14 mx-0 md:mx-14 absolute md:relative top-40 md:top-0 bg-black md:bg-transparent"
        :class="[open ? 'left-0' : '-left-[100%] md:left-0']"
      >
        <div
          v-for="navItem in navItems"
          :key="navItem.sectionId"
          class="my-10 md:my-0"
        >
          <li
            class="text-white list-none capitalize text-xl font-semi-bold cursor-pointer nav-links"
            @click.prevent="scrollToSection(navItem.sectionId)"
          >
            {{ navItem.name }}
          </li>
        </div>
      </div>
    </nav>

    <!-- hero section -->
    <section class="mt-96 md:mt-40 mb-40">
      <div
        class="flex flex-col md:flex-row justify-around items-center w-[90%]"
        :style="{ margin: '0 auto' }"
      >
        <!-- hero text -->
        <div class="flex justify-center items-center w-full md:w-1/2 h-auto">
          <!--typewritter effect -->
          <h1 class="text-4xl md:text-6xl text-white">
            <h2 class="capitalize text-xl font-semibold my-2">hi there,</h2>
            <p class="typed-text my-2">
              {{ typeValue }}
              <span class="blinking-cursor">|</span>
              <span class="cursor" :class="{ typing: typeStatus }">&nbsp;</span>
            </p>
            <p class="text-lg my-3">
          Welcome to my creative realm where graphics design, photography, and videography converge to ignite visual storytelling. Through a meticulous blend of artistry and technical skill, I strive to create captivating experiences that leave a lasting impact. Join me on a journey where every frame, every brushstroke, and every pixel is infused with passion and purpose. Let's transform your vision into an extraordinary masterpiece that resonates with authenticity and creativity.
            </p>
            <!-- Button -->
            <div
              class="cursor-pointer flex justify-center md:justify-start items-center"
            >
              <a href="mailto:emixOnu95@gmail.com">
                <Button :text="text" />
              </a>
            </div>
          </h1>
        </div>
        <!-- slideshow -->
        <div class="slideshow w-[350px] mt-20 md:mt-0">
          <img
            :src="currentImage"
            :key="currentImage"
            :style="{ animation: 'fade-in 1s' }"
          />
        </div>
      </div>
    </section>
  </section>
</template>

<style scoped>
.header-ctn {
  background-image: url("../assets/images/hero-bg-3.png");
  background-repeat: no-repeat;
  background-position: center;
}
.blinking-cursor {
  color: #fff;
  -webkit-animation: blink 1s step-end infinite;
  -moz-animation: blink 1s step-end infinite;
  -ms-animation: blink 1s step-end infinite;
  -o-animation: blink 1s step-end infinite;
  animation: blink 1s step-end infinite;
}
.cursor {
  visibility: hidden;
}
.typing .cursor {
  visibility: visible;
}
@keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@-moz-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@-webkit-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
    background-color: rgb(167, 126, 23);
  }
}
@-ms-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}
@-o-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: #2c3e50;
  }
}

/* image slideshow */
.slideshow img {
  animation-duration: 1s;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
